import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import RoleAccessLayer from "../../components/RoleAccessLayer";
import UsuariosLayer  from  "../../components/comprobantes/UsuariosLayer";

const Usuarios = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Usuarios" />

        {/* RoleAccessLayer */}
        <UsuariosLayer/>

      </MasterLayout>

    </>
  );
};

export default Usuarios; 
